import { SET_RESERVATION_INFO } from '../actions/taola'

const mutations = {
  [SET_RESERVATION_INFO](state, data) {
    state.reservationInfo = data;
  }
}

export default {
    namespaced : true,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/taola.js